export const Routes = {
  DESIGN: '/design',
  EXPORT: '/export',
  TEMPLATES: '/templates',
  PRIVATE_LINK_VIEW: '/pl',
};
